export default "/images/text-right.svg?49fc02d9ad09d9f8c3ddb0adf611026c";